import type { RBACRedirectConfig } from '@dfg/brahma-types';
import { ContextAction } from '../types';
import type { RBACRedirectConfigAction } from './types';

export const routeConfigReducer = (
  state: RBACRedirectConfig | undefined,
  action: RBACRedirectConfigAction
): RBACRedirectConfig | undefined => {
  switch (action.type) {
    case ContextAction.setRouteConfig:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
